<!--新闻类视频-->
<div class="video-news" [ngClass]="ngClass" *ngIf="display === videoDisplay.News">
  <div class="poster">
    <a [routerLink]="['/watch']" [queryParams]="{v:video.key}">
      <img src="{{'./assets/images/loading_216x122.png?v=2'|absUrl}}"
        dataSrc="{{video.image+ '?w=216&h=122&format=jpg&mode=crop' | safeResource}}" [lazyLoad]
        alt="{{video.title}}" />
    </a>
  </div>
  <div class="right">
    <a class="d-block mb-4" [routerLink]="['/watch']" [queryParams]="{v:video.key}">
      <h5>{{ video.title }}</h5>
      <div class="bottom">
        <div class="item"><i class="dn-icon-medium icon-watch"></i><span class="text-light">{{ video.userData.viewCount
            | chineseCounter }}</span></div>
        <div class="item"><i class="dn-icon-medium icon-comment"></i><span class="text-light">{{ video.userData.comments
            | chineseCounter }}</span></div>
      </div>

    </a>
  </div>
</div>

<div class="video-teaser news-block" *ngIf="!!video && display === videoDisplay.NewsBlock">
  <a title="{{ video.title }}" [routerLink]="['/watch']" [queryParams]="{v:video.key }">
    <div class="v-content d-block position-relative">
      <div class="recommended" *ngIf="video.recommended"></div>
      <div class="updated" *ngIf="video.updates && video.updates > 0">{{ video.updates }}</div>
      <img class="poster d-block" src="{{'./assets/images/loading_216x122.png?v=2' | absUrl}}"
        dataSrc="{{ video.image  | safeResource:true }}?w=216&h=122&format=jpg&mode=crop" [lazyLoad]
        alt="{{video.title}}" />
      <div class="shadow-bar"></div>
      <div class="view-count">
        <i class="dn-icon-small icon-watch text-white"></i>
        <span class="num">{{video.videoLength || (video.lastseconds.split('.')[0].split(':').slice(1).join(':'))}}</span>
        <!-- <span class="num"
                      *ngIf="video.userData.viewCount < 10000">{{ video.userData.viewCount | chineseCounter }}</span>
                  <span class="num text-red"
                      *ngIf="video.userData.viewCount > 9999"><b>{{ video.userData.viewCount | chineseCounter }}</b></span> -->
      </div>
    </div>
  </a>
  <div class="title-box news-title">
    <a [routerLink]="[ '/watch'] " [queryParams]="{v: video.key}" title="{{ video.title }}">{{
      video.title }}</a>

  </div>
</div>

<!-- 
<div class="video-teaser channel-list" *ngIf="!!video && display === videoDisplay.ChannelBlock">
  <a title="{{ video.title }}" [routerLink]="[ '/space',video.key]">
    <div class="v-content d-block position-relative" lazy-load-images>
      <div class="recommended" *ngIf="video.recommended"></div>
      <div class="updated" *ngIf="video.updates && video.updates > 0">{{ video.updates }}</div>
      <img class="poster d-block" src="{{'./assets/images/loading_216x122.png' | absUrl}}"
        dataSrc="{{video.image  | safeResource:true}}?w=216&h=122&format=jpg&mode=crop" [lazyLoad] />

      <div class="view-count" *ngIf="video.userData !=null">
        <i class="dn-icon-small icon-watch text-white"></i>
        <span class="num">{{ video.videoLength }}</span>
      
      </div>
    </div>
  </a>
  <div class="title-box ">
    <div class="news-title"><a [routerLink]="[ '/channel',video.key]">{{ video.title }}</a></div>
    <div *ngIf="video.category==='movie' ||  video.category==='chinese'" class="text-small text-light ">
      <span>{{ video.genre }}</span>
    </div>
    <div *ngIf="isAdult && video.tags !=null" class="text-small text-light ">
      <span>{{ video.tags.join('　') }}</span>
    </div>
    <div *ngIf="!isAdult && video.category !=='movie' && video.category !=='chinese' " class="text-small text-light"
      [innerHTML]="refactorLastUpdate()"></div>
  </div>
</div> -->